<template>
  <el-popover placement="bottom" width="200" trigger="hover" @show="getQrcodeImage">
    <el-image style="width: 200px; height: 200px" :src="wechatQRCodeLink">
      <template v-slot:placeholder>
        <div class="image-slot">{{ $t("common.jia-zai-zhong") }}<span class="dot">...</span></div>
      </template>
      <template v-slot:error>
        <div class="image-slot">{{ $t("common.jia-zai-zhong") }}<span class="dot">...</span></div>
      </template>
    </el-image>
    <p style="line-height: 30px; text-align: center">{{ $t("common.Scan-Follow") }}</p>
    <template v-slot:reference>
      <el-button type="text" class="margin-left-8 noPadding">{{ $t("common.Follow-Official") }}</el-button>
    </template>
  </el-popover>
</template>
<script>
export default {
  data() {
    return {
      wechatQRCodeLink: "",
    };
  },
  methods: {
    async getQrcodeImage() {
      try {
        const res = await this.$axios.getQrcodeImage();
        if (res.code == 1) {
          this.wechatQRCodeLink = res.data.qrcode_info.url;
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
